import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 2),
  },
  title: {
    marginBottom: theme.spacing(6),
    fontSize: 32,
  },
  smallerTitle: {
    fontSize: 26,
  },
  text: {
    lineHeight: 1.75,
  },
  image: {
    alignSelf: 'center',
  },
  imageTop: {
    marginBottom: theme.spacing(6),
  },
  imageBottom: {
    marginTop: theme.spacing(6),
  },
  center: {
    height: '67vh',
    justifyContent: 'center',
  },
});

function InfoScreen({
  classes,
  image,
  imageLocation,
  title,
  titleVariant,
  text,
  imageAlt,
  imageWidth,
  centered,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  if (!resource) return null;

  return (
    <div className={classNames(classes.root, {
      [classes.center]: centered,
    })}
    >

      {(imageLocation === 'top') && (
        <img
          src={image}
          alt={imageAlt}
          width={imageWidth}
          className={classNames(classes.image, classes.imageTop)}
        />
      )}

      <Typography
        variant={titleVariant}
        color="primary"
        className={classNames(classes.title, { [classes.smallerTitle]: titleVariant === 'h2' })}
        weight="medium"
        align="center"
      >
        {title}
      </Typography>

      <Typography
        className={classes.text}
        color="primaryGray2"
        variant="h4"
        weight="book"
        align="center"
      >
        {text}
      </Typography>

      {(imageLocation === 'bottom') && (
        <img
          src={image}
          alt={imageAlt}
          width={imageWidth}
          className={classNames(classes.image, classes.imageBottom)}
        />
      )}

    </div>
  );
}

InfoScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  text: PropTypes.string.isRequired,
  image: PropTypes.node,
  imageAlt: PropTypes.string,
  imageLocation: PropTypes.string,
  imageWidth: PropTypes.number,
  centered: PropTypes.bool,
};

InfoScreen.defaultProps = {
  titleVariant: 'h1',
  image: null,
  imageAlt: '',
  imageLocation: 'top',
  imageWidth: 50,
  centered: false,
};

export default withStyles(styles)(InfoScreen);
